import { render, staticRenderFns } from "./LiveEvent.vue?vue&type=template&id=eb3caed4&scoped=true&"
import script from "./LiveEvent.vue?vue&type=script&lang=js&"
export * from "./LiveEvent.vue?vue&type=script&lang=js&"
import style0 from "./LiveEvent.vue?vue&type=style&index=0&id=eb3caed4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3caed4",
  null
  
)

export default component.exports